export interface IDocumentSettingsSave {
    message: string;
    refreshFolders: boolean;
}

export class DocumentSettingsSave implements IDocumentSettingsSave {
    message: string;
    refreshFolders: boolean;

    constructor();
    constructor(obj: IDocumentSettingsSave);
    constructor(obj?: any) {
        this.message = obj && obj.message || "";
        this.refreshFolders = obj && obj.refreshFolders || false;
    }
}